<template lang="pug">
    .counter-widget
        header.header
            .level
                .level-left
                    .title.is-4
                        span.icon.is-medium
                            i.fas.fa-calculator
                        span New users
                .level-right
                    .title.tags.has-addons
                        span.tag.has-text-weight-bold.is-black {{ total }}
        .columns.data-list.is-mobile.is-multiline.is-gapless
            .column.is-full
                .card(v-for="(user, i) in users" :key="user.createdAt")
                  .card-content
                    .media
                      .media-left
                        figure.image.is-48x48
                          span.icon.is-large(:class="{ 'has-text-success': hasSubscription(user.subscription) }")
                            i.fas.fa-money-check-alt.fa-2x
                      .media-content
                        .title.is-4.level
                          .level-left {{ user.username }}
                          .level-rigth.is-size-7 {{ dateFormat(user.registrationOn) }}
                        .subtitle.is-6 {{ user.email }}
</template>

<script>
import moment from "moment";

export default {
  name: "UsersWidget",
  props: ["users", "total"],
  methods: {
    dateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    hasSubscription(s) {
      if (!s || !s._id) return false;
      return new Date() > new Date(s.start) && new Date() < new Date(s.end);
    }
  }
};
</script>

<style lang="scss" scoped>
.counter-widget {
  position: relative;
  display: block;
  width: 100%;
  background: linear-gradient(180deg, #0bab64 0%, #3bb78f 100%);
  border-radius: 5px;

  .opacity {
    opacity: 0.8;
  }

  .header {
    position: relative;
    padding-bottom: 0.3rem;
    overflow: hidden;
    .level {
      padding: 1rem;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $defaultColor;

        .icon {
          margin-right: 0.5rem;
        }
      }
    }
  }

  .data-list {
    .container {
      padding: 0.5rem;
    }

    .card {
      box-shadow: none;
      background-color: rgba(0, 0, 0, 0.05);
      &:nth-child(odd) {
        background-color: rgba(0, 0, 0, 0.1);
      }
      .card-content {
        padding: 0.3rem 1rem;
        box-shadow: none;
      }
    }
  }
}
</style>
